import { React, useState, useEffect } from "react"
import { sha256 } from "js-sha256"
import SweetAlert from "react-bootstrap-sweetalert"

const loader = document.querySelector(".loader")
const authCheck = props => {
  const params = new URLSearchParams(window.location.search)
  const qtoken = params.get("token")
  const ene = params.get("ene")

  const base64Encode = data => {
    let buff = new Buffer.from(data)
    return buff.toString("base64")
  }

  const base64Decode = data => {
    let buff = new Buffer.from(data, "base64")
    return buff.toString("ascii")
  }
  
  // const hashstr = sha256.update("abc").update("bcd").update("def").hex();
  // console.log(hashstr);

  const enco = (lEmail, logTime) => {
    const encodedlEmail = base64Encode(lEmail.toString())
        // console.log(encodedlEmail);
    const encodedlogTime = base64Encode(logTime.toString())
    const encodedsecret = base64Encode(process.env.REACT_APP_SECRET.toString())

    const token = sha256
      .update(encodedlEmail)
      .update(encodedlogTime)
      .update(encodedsecret)
      .hex()
          // console.log('http://localhost:9000/login/check/'+token+'/'+encodedlEmail);

    return token
  }

  // For login success alert
  const [successalert, setsuccessAlert] = useState(false)

  // For login fail alert
  const [alert, setFailAlert] = useState(false)
  const alertToggle = () => {
    setFailAlert(!alert)
  }
  
  const [redirect, setredirect] = useState(false)
  const redirectToggle = () => {
    if (redirect) window.location.href = "/login"
  }

  useEffect(() => {
    const loader = document.querySelector(".loader")
    
    setTimeout(() => {
      if (loader) {
        loader.classList.add("loader--hide")
      }
    }, 1000)

    async function postData(url = "", data = {}) {
      const response = await fetch(url, {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
        },
        redirect: "follow",
        referrerPolicy: "no-referrer",
        body: JSON.stringify(data),
      })
      return response.json()
    }

    const vlogTime = Date.now()
    const decodedlEmail = base64Decode(ene)

    postData(process.env.REACT_APP_ADMIN + "/login/get/document", {
      Email: decodedlEmail,
      token: process.env.REACT_APP_SECRET,
    }).then(document => {
      if (!document.mssg) {
        if (document.Timestamp == document.lastLogin) {
          console.log("[AuthCheck] Invalid link - first login attempt")
                  // window.location.href = "/login/fail";
          setFailAlert(true)
          setredirect(true)
          console.log("Invalid link, Please generate again")
        } else {
          const verifytoken = enco(decodedlEmail, document.Timestamp)
          console.log("[AuthCheck] Email:", decodedlEmail)
          console.log("[AuthCheck] Time:", document.Timestamp)
          console.log("[AuthCheck] Verify token:", verifytoken)
          console.log("[AuthCheck] Query token:", qtoken)
          
          if (verifytoken == qtoken) {
            console.log("[AuthCheck] Token verified!")
            const vlogTime = Date.now()
            
            postData(process.env.REACT_APP_ADMIN + "/login/update/document", {
              Email: decodedlEmail,
              token: process.env.REACT_APP_SECRET,
              vlogTime,
            }).then(doc => {
              if (!doc.mssg) {
                console.log("[AuthCheck] Login successful, setting localStorage items")
                
                // IMPORTANT: Set both authUser AND datasaved
                localStorage.setItem("authUser", JSON.stringify(doc))
                localStorage.setItem("datasaved", "true") // NEW: Set datasaved flag to prevent re-login
                
                setsuccessAlert(true)
                
                // Redirect after a short delay
                setTimeout(() => {
                  window.location.href = "/dashboard"
                }, 1500)
              } else {
                              // window.location.href = "/login/fail";
                console.error("[AuthCheck] Login update failed:", doc.mssg)
                setFailAlert(true)
                setredirect(true)
              }
            }).catch(error => {
              console.error("[AuthCheck] Error updating document:", error)
              setFailAlert(true)
              setredirect(true)
            })
          } else {
                      // window.location.href = "/login/fail";
            console.error("[AuthCheck] Token verification failed")
            setFailAlert(true)
            setredirect(true)
            console.log({ mssg: "Invalid Link, Please TRY AGAIN" })
          }
        }
      } else {
        console.error("[AuthCheck] Document fetch error:", document.mssg)
        setFailAlert(true)
        setredirect(true)
        console.log({ mssg: "Something Went wrong, TRY AGAIN!" })
      }
    }).catch(error => {
      console.error("[AuthCheck] Error during auth check:", error)
      setFailAlert(true)
      setredirect(true)
            console.log({ mss: "Something Went wrong, TRY AGAIN! " })
    })
  }, [ene, qtoken])

  return (
    <div>
      <SweetAlert
        show={alert}
        danger
        title="Login Failed!"
        onConfirm={redirectToggle}
                // timeout={4000}
      >
        You will be redirected to the login page. Please enter your email ID to
        log in.
      </SweetAlert>
       {/* <SweetAlert
                show={successalert}
                title={"Uses render props"}
                onConfirm={this.onConfirm}
                type={'controlled'}
                dependencies={[this.state.firstName, this.state.lastName]}
            >
                
                    <form>
                        Your name is: 
                        <hr />
                        <input
                            type={'text'}
                            ref={renderProps.setAutoFocusInputRef}
                            className="form-control"
                            value=""
                            onKeyDown={renderProps.onEnterKeyDownConfirm}
                            onChange={(e) => this.setState({ firstName: e.target.value })}
                            placeholder={'First name'}
                        />
                        <br />
                        <input
                            type={'text'}
                            className="form-control"
                            value=""
                            onKeyDown={renderProps.onEnterKeyDownConfirm}
                            // onChange={(e) => this.setState({ lastName: e.target.value })}
                            placeholder={'Last name'}
                        />
                        <hr />
                    </form>
                
            </SweetAlert> */}
      <SweetAlert
        show={successalert}
        success
        title="Login Success!"
         // onConfirm={redirectToggle}
        // timeout={4000}
      >
        Successfully logged in! Redirecting to dashboard...
              {/* You will be redirected to the login page. Please enter your email ID to log in. */}
      </SweetAlert>
    </div>
  )
}

export default authCheck